import createInlineButtons from './inline-buttons.js';
import createInsertButtons from './insert-buttons.js';
import 'wix-rich-content-plugin-commons';
import '../defaults.js';
import './HtmlEditPanelDraft.js';
import 'react';
import './HtmlEditPanel.js';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import 'lodash';
import '../AdsenseTitle.js';
import '../style-inject.es-746bb8ed.js';
import '../icons/EditIcon.js';
import 'wix-rich-content-editor-common';
import '../icons/InsertPluginIcon.js';
import '../icons/Adsense.js';

const createToolbar = ({
  helpers,
  t,
  isMobile,
  settings,
  getEditorBounds
}) => {
  return {
    InlineButtons: createInlineButtons({ settings, getEditorBounds }),
    InsertButtons: isMobile ? [] : createInsertButtons({ helpers, t, settings }),
    name: "html"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
